<template>
    <div class="securitySection">
        <div class="securityCards">
            <picture class="securityImg">
                <source :srcset="require('@/assets/icons/protection-stock-entrepot.webp')" type='image/webp' />
                <img :src="require('@/assets/icons/protection-stock-entrepot.png')" alt="Icône bouclier représentant la sécurité des entrepôt GMA logistics" loading="lazy" />
            </picture>
            <h3 class="securityTitle">{{ $t('security.title1') }}</h3>
            <div class="paraf">{{ $t('security.content1') }}</div>
            <div class="paraf">{{ $t('security.content1b') }}</div>
        </div>
        <div class="securityCards">
            <picture class="securityImg">
                <source :srcset="require('@/assets/icons/securite-entreposage-GMA-logistics.webp')" type='image/webp' />
                <img :src="require('@/assets/icons/securite-entreposage-GMA-logistics.png')" alt="Icône feu pour la gestion des préventions et normes de sécurité incendie" loading="lazy" />
            </picture>
            <h3 class="securityTitle">{{ $t('security.title2') }}</h3>
            <div class="paraf">{{ $t('security.content2') }}</div>
            <div class="paraf">{{ $t('security.content2b') }}</div>
        </div>
        <div class="securityCards">
             <picture class="securityImg">
                <source :srcset="require('@/assets/icons/gestion-stock-optimale.webp')" type='image/webp' />
                <img :src="require('@/assets/icons/gestion-stock-optimale.png')" alt="Icône de médaille signifiant l'engagement de GMA sur la qualité, sécurité et environnement" loading="lazy" />
            </picture>
            <h3 class="securityTitle">{{ $t('security.title3') }}</h3>
            <div class="paraf">{{ $t('security.content3') }}</div>
            <div class="reasons">
                <div class="">{{ $t('security.reason1') }}</div>
                <div class="">{{ $t('security.reason2') }}</div>
                <div class="">{{ $t('security.reason3') }}</div>
                <div class="">{{ $t('security.reason4') }}</div>
            </div>
            <div class="paraf">{{ $t('security.content3b') }}</div>
        </div>
    </div>
</template>

<style scoped>
.securitySection {
    display: flex;
    justify-content: space-between;
    gap: 60px;
    text-align: left;
    max-width: 1440px;
    margin: 150px auto;
}
.securityCards {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 50px;
    box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.2);
    border-radius: 30px;
}
.securityImg {
    width: 70px;
    height: 70px;
    margin-top: -150px;
    border-radius: 100%;
    text-align: center;
    align-self: center;
    padding: 40px;
    background-color: #ffffff;
    box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.2);
}
.securityImg > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.reasons {
    padding: 0 0 15px 10px;
}
@media screen and (min-width: 2000px ) {
    .securitySection {
        max-width: 1440px;
        place-self: center;
        margin-top: 200px;
    }
}
@media screen and (max-width: 750px ) {
    .securitySection {
        flex-direction: column;
        margin: 130px 0 0 0;
    }
    .securityCards {
        margin: 0 30px 70px;

    }
    .securityImg {
        width: 45px;
        height: 45px;
        padding: 30px;
        margin-top: -115px;
    }
    h3 {
        font-size: 30px;
    }
}
</style>